export type ViewMode = "lookbook" | "grid" | "list";
export type GridColumns = "auto" | 1 | 2 | 3 | 4 | 5 | 6;

export type ViewPreferences = {
  viewMode: ViewMode;
  gridColumns: GridColumns;
  hideUnavailablePrimagi: boolean;
  hideCoordinateQr: boolean;
  qrCycleSeconds: number;
};

export const DEFAULT_VIEW_PREFERENCES: ViewPreferences = {
  viewMode: "lookbook",
  gridColumns: "auto",
  hideUnavailablePrimagi: false,
  hideCoordinateQr: false,
  qrCycleSeconds: 2.5,
};

export function normalizeViewPreferences(value: unknown): ViewPreferences {
  if (!value || typeof value !== "object") return { ...DEFAULT_VIEW_PREFERENCES };
  const source = value as Partial<Record<keyof ViewPreferences, unknown>>;
  const viewMode: ViewMode = source.viewMode === "lookbook" || source.viewMode === "list"
    ? source.viewMode
    : "grid";
  const numericColumns = typeof source.gridColumns === "number" ? source.gridColumns : Number.NaN;
  const gridColumns: GridColumns = source.gridColumns === "auto"
    ? "auto"
    : Number.isInteger(numericColumns) && numericColumns >= 1 && numericColumns <= 6
      ? numericColumns as GridColumns
      : "auto";
  const rawQrCycleSeconds = typeof source.qrCycleSeconds === "number"
    ? source.qrCycleSeconds
    : Number.NaN;
  const qrCycleSeconds = Number.isFinite(rawQrCycleSeconds)
    ? Math.min(2.5, Math.max(0.3, Math.round(rawQrCycleSeconds * 10) / 10))
    : DEFAULT_VIEW_PREFERENCES.qrCycleSeconds;
  return {
    viewMode,
    gridColumns,
    hideUnavailablePrimagi: source.hideUnavailablePrimagi === true,
    hideCoordinateQr: source.hideCoordinateQr === true,
    qrCycleSeconds,
  };
}
